import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { AuthenticationService } from '@/apiConnection/authentication.service';
import { CashClosingFormComponent } from '../cash-closing-form/cash-closing-form.component';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
    CentToEurDisplayDirective,
  ],
  templateUrl: './cash-closing-list.page.html',
  encapsulation: ViewEncapsulation.None
})
export class CashClosingListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);
  private authService = inject(AuthenticationService);

  public url = Urls.urls.cashClosings;

  public headers = [
    { name: 'Cierre', key: 'period_end', type: 'dateTime' },
    { name: 'Oficina', key: 'office.name' },
    { name: 'Usuario', key: 'user.name' },
    { name: 'Tickets', key: 'tickets_count' },
    { name: 'Total ventas', key: 'total_sales' },
    { name: 'Efectivo esperado', key: 'expected_cash' },
    { name: 'Efectivo contado', key: 'counted_cash' },
    { name: 'Descuadre', key: 'difference' },
  ];

  public filterConfig: any = {
    order: ['dateRange'],
    mobile: ['dateRange'],
    form: {
      dateRange: {
        name: 'Periodo',
        key: 'date_start',
        keyTo: 'date_end',
        type: 'dateRange',
        defaultValue: []
      },
    }
  };

  get canCreate(): boolean {
    return this.authService.hasPanel('cash_closings', 'can_create');
  }

  canDelete = (): boolean => this.authService.hasPanel('cash_closings', 'can_delete');

  print(item: { id: number }) {
    window.open(`/cash-closing/print/${item.id}`, '_blank');
  }

  openForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CashClosingFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'cierre de caja';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
